/**
 * As duas rotas de entrada do dominio Apontamentos (T75, R7).
 *
 * **DUAS rotas, e ate a T139 as duas declaravam o MESMO `name`.** O Vue Router
 * trata nome como chave unica: ao registrar a segunda, ele removia a primeira.
 * O efeito medido era que `/cre/apontamentos` caia no 404 — nao no 403, ou seja
 * nao era o guard negando — e o menu do grupo CRE oferecia um item morto,
 * porque as duas pediam `showMenu`.
 *
 * A T74 achou isso ao LIGAR o gate de smoke do dominio, e nao por leitura de
 * codigo: o primeiro caso apontava para `/cre/apontamentos` e reprovou
 * desenhando a tela de 404.
 *
 * **O conserto foi so o nome, e essa e a segunda versao da decisao da area.** A
 * primeira resposta foi "a primeira e a verdadeira", o que se aplicaria
 * REMOVENDO a rota de fabrica — e eu registrei, no commit que a aplicava, que o
 * efeito medido era inverter quem abre a tela: quem tinha so `PROJETO_FABRICA`
 * era exatamente quem conseguia abrir, porque a rota de fabrica era a que
 * sobrevivia a colisao. Com esse numero na mao, a area reconsiderou e escolheu
 * a saida que **nao tira acesso de ninguem**: as duas rotas ficam, cada uma com
 * o seu `subject`, e o nome deixa de colidir.
 *
 * **O nome da segunda e DERIVADO, e nao inventado** (criterio da T139): a rota
 * canonica fica com o nome do dominio, e a outra recebe
 * `<Dominio> <meta.grupo>`. Aqui o grupo e "Projetos Fábrica", entao o nome e
 * "Apontamentos Projetos Fábrica". Medido antes de trocar: nenhum codigo fora
 * de `views/Apontamentos/` compara o nome desta rota
 * (`grep -rn '"Apontamentos"' src/`), entao a troca nao quebra navegacao por
 * nome.
 *
 * Havia aqui um `const metaPadrao` com subject, action, showMenu e grupo do CRE
 * — **codigo morto**: nenhuma das duas rotas o usava, cada uma repetia o objeto
 * inteiro no proprio `meta`. Removido no PR que poe o arquivo em stage
 * (ADR-0001), e a remocao e inerte: nada o lia.
 */
export default [
  {
    path: "cre/apontamentos",
    name: "Apontamentos",
    component: () => import("@/views/Apontamentos/ApontamentosDashboard.vue"),
    meta: {
      breadcrumb: "",
      title: "Apontamentos de horas técnicas",
      icon: "mdi-timer-sand",
      subject: ["PROJETO"],
      action: ["read"],
      showMenu: true,
      grupo: "CRE",
      grupoTitle: "CRE",
    },
  },
  {
    path: "projetos-fabrica/apontamentos",
    name: "Apontamentos Projetos Fábrica",
    component: () => import("@/views/Apontamentos/ApontamentosDashboard.vue"),
    meta: {
      breadcrumb: "",
      title: "Apontamentos de horas técnicas",
      icon: "mdi-timer-sand",
      subject: ["PROJETO_FABRICA"],
      action: ["read"],
      showMenu: true,
      grupo: "Projetos Fábrica",
      grupoTitle: "Projetos Fábrica",
    },
  },
];
